export default "__VITE_ASSET__4c9584d4__"